import { RawModel } from '@/types/rawModel';
import { getDownloadUrlsForRawModel } from '@/app/assets/actions/downloads';

type GetDownloadUrlParams = {
  asset: RawModel;
};

type DownloadUrl = { name: string; url: string };

export const getDownloadUrls = async ({ asset }: GetDownloadUrlParams): Promise<DownloadUrl[]> => {
  return getDownloadUrlsForRawModel(asset.id);
};
